module.exports = __webpack_public_path__ + "img/station.88b4cd28.png";